import { z } from 'zod';

export const billingSchema = z.object({
	name: z.string().min(2, 'Name is required'),
	phone: z.string().regex(/^[6-9]\d{9}$/, 'Invalid phone'),
	address: z.string().min(5, 'Address required'),
	country: z.string().min(2, 'Country required'),
	pincode: z.string().regex(/^\d{6}$/, 'Invalid pincode'),
	city: z.string().min(2, 'City required'),
	state: z.string().min(2, 'State required'),
	gst: z.boolean().optional(),
	gstin: z.string().optional(),
	paymentType: z.enum(['recurring', 'one-time']),
	paymentMethod: z.enum(['card', 'upi']),
});
